import { useEffect, useLayoutEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { GoogleButton } from '../../auth/GoogleButton';
import { CreateAccountForm } from '../../blocks/CreateAccountForm';
import { WhiteBox } from '../../blocks/WhiteBox';
import { PageBody } from '../../layout/AppLayout';
import { h2ClassName, linkClassName } from '../../components/ui/styles';
import { useSession } from '@/context/session/useSession';

export function AccountAuthPage() {
  const [isSignIn, setSignIn] = useState(false);
  const { session } = useSession();
  const navigate = useNavigate();
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.pathname === '/account/signup') {
      setSignIn(false);
    } else if (location.pathname === '/account/signin') {
      setSignIn(true);
    }
  }, [location]);

  useEffect(() => {
    if (session) navigate('/');
  }, [navigate, session]);

  if (session) {
    return (
      <>
        <PageBody>
          <div>
            <div className="text-xl font-bold leading-7 text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
              Signed in successfully
            </div>
          </div>
          <div>
            <h2 className={h2ClassName}>{session.user.email}</h2>
          </div>
          <div>
            <div className="p-5 border border-indigo-200 bg-indigo-50 rounded text-indigo-900 font-semibold my-5">
              Redirecting...
            </div>
          </div>
        </PageBody>
      </>
    );
  }

  return (
    <>
      <PageBody>
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <WhiteBox>
            <GoogleButton />

            <h2 className="mt-6  text-2xl font-bold leading-9 tracking-tight text-gray-900">
              {isSignIn ? 'Sign in' : 'Sign up'} with email
            </h2>
            <CreateAccountForm isExistingAccount={isSignIn} />
            <div className="pt-4 text-center">
              {isSignIn
                ? "Doesn't have an account?"
                : 'Already have an account?'}{' '}
              <NavLink
                to={isSignIn ? '/account/signup' : '/account/signin'}
                className={linkClassName}
              >
                {isSignIn ? 'Sign up' : 'Sign in'}
              </NavLink>
            </div>
            {isSignIn && (
              <div className="pt-4 text-center">
                <NavLink to="/account/reset-password" className={linkClassName}>
                  Reset password
                </NavLink>
              </div>
            )}
          </WhiteBox>
        </div>
      </PageBody>
    </>
  );
}
